import * as TYPES from './message-bar-actiontypes';
import * as MESSAGE_TYPES from './message-types';

export const showMessage = (msgType, msgCode, msgParameters, keepDisplay) => {
  const state = {
    messageType: msgType,
    messageCode: msgCode, // code of the international message defined in Message.i18n.js, or just any message
    messageParameters: msgParameters, // an array of any required parameters that need to be used in the message
    keepDisplay,
  };

  return {
    type: TYPES.MESSAGE_BAR_DISPLAY,
    state,
  };
};

export const showStickySuccessMessage = (msgCode, msgParameters) =>
  showMessage(MESSAGE_TYPES.MESSAGE_TYPE_SUCCESS, msgCode, msgParameters, true);

export const showSuccessMessage = (msgCode, msgParameters) =>
  showMessage(MESSAGE_TYPES.MESSAGE_TYPE_SUCCESS, msgCode, msgParameters, false);

export const showErrorMessage = (msgCode, msgParameters) =>
  showMessage(MESSAGE_TYPES.MESSAGE_TYPE_ERROR, msgCode, msgParameters, false);

export const showStickyWarningMessage = (msgCode, msgParameters) =>
  showMessage(MESSAGE_TYPES.MESSAGE_TYPE_WARNING, msgCode, msgParameters, true);

export const showStickyErrorMessage = (msgCode, msgParameters) =>
  showMessage(MESSAGE_TYPES.MESSAGE_TYPE_ERROR, msgCode, msgParameters, true);

export const dismissMessage = () => ({
  type: TYPES.MESSAGE_BAR_DISMISS,
});

export const setMessageFlagDismiss = () => ({
  type: TYPES.MESSAGE_BAR_FLAG,
  state: {
    keepDisplay: false,
  },
});

export const retrieveMessage = () => ({
  type: TYPES.RETRIEVE_MESSAGE,
});
